import router from './router'
import store from './store'
// import 'nprogress/nprogress.css' // progress bar style
import { getScreenToken } from '@/utils/auth'

// 路由拦截，路由在跳转前要执行什么
// to: 即将进入的路由
// from: 即将离开的路由
// next: 下一个  管道勾子
router.beforeEach(async (to, from, next) => {

  // 如果img接口token
  // if (!store.getters.imgToken) {
  //   // console.log(77777)
  //   next({path: '/login'})
  // }
  // 1、是否是登录页
  if (to.path === '/login') {
    next()
  } else { // 2、登录分角色：管理员/其他
    if (window.name && to.path ==='/map') {
      await store.dispatch('SET_SHIPS_TOKEN', window.name)
    }
    const hasToken = getScreenToken() !== null
    if (hasToken) {
      next()
    } else {
      try {
        next({path: '/login'})
      } catch (error) {
        next({path: '/login'})
      }
    }
  }
})
